import {GET_BRAND} from "../../redux/types";

export const GET_BRAND_START = "GET_BRAND_START";

export const getBrand = () => dispatch => {
    dispatch({type: GET_BRAND_START});
    dispatch({type: GET_BRAND});
};



// WEBPACK FOOTER //
// ./src/components/brand/BrandActions.js